import React, { useContext } from "react";
import "../../stylesheet/component.css";
import "../../stylesheet/forms.css";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { addInventory, editInventory } from "../../Utils/localStore";
import ToastContext from "../../context/toasterContex";

const InventorySummary = ({ data, goBack }) => {
  const { toast } = useContext(ToastContext)
  const navigate = useNavigate()

  const [searchParams] = useSearchParams();
  const queryParams = searchParams.get('mode');
  const edit = queryParams

  let today = Date.now()
  const formatter = new Intl.DateTimeFormat('en-NG', {
    dateStyle: 'full',
    timeStyle: 'long',
  })
  today = formatter.format(today);
  today = today.split('At')[0]

  const handleFormSubmit = async (e) => {
    e.preventDefault()
    if (!edit) {
      const newBilling = { ...data, date: today, status: 'Active' }
      console.log({ newBilling });
      await addInventory(newBilling)
        .then(resp => {
          toast.success('Inventory Added successfully', { position: toast.POSITION.TOP_CENTER })
          navigate('/inventory/all_inventories')
        })
        .catch(err => {
          toast.error('Something went wrong, please try again later', { position: toast.POSITION.TOP_CENTER })
          throw new Error(err)
        })
    } else {
      await editInventory(data)
        .then(resp => {
          toast.success('Inventory updated successfully', { position: toast.POSITION.TOP_CENTER })
          navigate('/inventory/all_inventories')
        })
        .catch(err => {
          console.log({ err });
          toast.error('Something went wrong, please try again later', { position: toast.POSITION.TOP_CENTER })
          throw new Error(err)
        })
    }
  }

  return (
    <div
      className="relative w-full font-euclid-circular-a"
    >
      <div>
        <h1 className="text-sky-500 text-3xl  pt-10 font-bold font-euclid-circular-a ">
          Inventory Summary
        </h1>
        <p className="pt-10 px-6">
          Review all inventory information before confirming entry.
        </p>
      </div>

      <div className="flex justify-center flex-col-reverse lg:flex-row p-4 lg:p-6 gap-5">
        <div className="w-full lg:w-4/5 overflow-y-auto lg:mt-8 summary-steps">
          <div className="mt-8 summary-steps">
            <h1 className="font-bold mb-3">Inventory Details</h1>
            <div className="border border-gray-400 rounded-md p-3">
              <div>
                <h4 className="text-gray-400">Inventory Name: </h4>
                <p>{data?.name || '-'}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-3">Brand: </h4>
                <p>{data?.brand || '-'}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-3">Category: </h4>
                <p>{data?.category || '-'}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Quantity: </h4>
                <p>{data?.quantity || '-'}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Unit measurement: </h4>
                <p>{data?.measurement || '-'}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">
                  Minimum alert notifications:
                </h4>
                <p>{data?.alert || '-'}</p>
              </div>

              <div>
                <h4 className="text-gray-400 mt-4">Price: </h4>
                <p>{data?.price || '-'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/5">
          {/* onClick={goBack} */}
          <button onClick={goBack} type="button" className="border-primary border p-2 rounded min-w-40" >
            Edit
          </button>
          <div className="my-3">
            <button onClick={handleFormSubmit}
              type="button"
              className="rounded text-white bg-primary p-2 min-w-40"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default InventorySummary
